import { Injectable, inject } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patchState } from '../../nested-value-getter';
import { OrmService } from '../../schema/orm.service';
import { IssuesFirestoreService } from '../../services/issue.firestore.service';
import { IssueActions } from './issue.action';
import { IssueStateModel } from './issue.store';

@State<IssueStateModel>({
  name: 'issues',
  defaults: {
    issues: [],
    isSubscribed: false,
    isLoading: false,
    filter: undefined,
  },
})
@Injectable()
export class IssueState {
  private issueService = inject(IssuesFirestoreService);
  private dbUser = inject(OrmService).userCollection;

  @Action(IssueActions.GetAllIssue)
  async getAllIssues(ctx: StateContext<IssueStateModel>) {
    ctx.patchState({ isLoading: true });
    const issues = await this.issueService.GetAll();
    ctx.patchState({ issues: issues.map(({ data, ref }) => ({ ...data, ref })), isLoading: false });
  }

  @Action(IssueActions.InitIssues)
  initMachines(ctx: StateContext<IssueStateModel>, { id }: IssueActions.InitIssues) {
    const state = ctx.getState();
    if (!state.isSubscribed) {
      ctx.patchState({ isSubscribed: true, isLoading: true });
      let off;
      if (id) {
        const { runs } = this.issueService.SetQuery({
          filterModel: { userId: { filter: this.dbUser.ref(this.dbUser.id(id)), type: 'equals' } },
        });
        off = this.issueService.OnQueryAll(runs, (issues) => {
          ctx.patchState({
            issues: issues
              .filter((issue): issue is NonNullable<typeof issue> => Boolean(issue))
              .map(({ data, ref }) => ({ ...data, ref })),
            isLoading: false,
          });
        });
      } else {
        off = this.issueService.OnGetAll((data) => ctx.dispatch(new IssueActions.UpdateIssueResult(data)));
      }
      off.catch((err) => ctx.dispatch(new IssueActions.IssueError(err as Error)));
      ctx.patchState({ off });
    }
  }

  @Action(IssueActions.CloseIssuesConnection)
  closeMachinesConnection(ctx: StateContext<IssueStateModel>) {
    const state = ctx.getState();
    if (state.isSubscribed && state.off) {
      state.off();
    }
    ctx.patchState({ isSubscribed: false });
  }

  @Action(IssueActions.UpdateIssue)
  async updateMachine(ctx: StateContext<IssueStateModel>, { issueData, ref }: IssueActions.UpdateIssue) {
    await this.issueService.Update(ref, issueData);
  }

  @Action(IssueActions.UpdateIssueResult)
  updateIssueResult(ctx: StateContext<IssueStateModel>, { data }: IssueActions.UpdateIssueResult) {
    patchState<IssueStateModel>(ctx, 'issues', data);
  }

  @Action(IssueActions.QueryIssue)
  async queryIssue(ctx: StateContext<IssueStateModel>, { filter }: IssueActions.QueryIssue) {
    ctx.patchState({ isLoading: true });
    const issues = await this.issueService.QueryAll(filter.query);
    ctx.patchState({ issues: issues.map(({ data, ref }) => ({ ...data, ref })), isLoading: false });
  }

  @Action(IssueActions.IssueError)
  machineError(ctx: StateContext<IssueStateModel>, { error }: IssueActions.IssueError) {
    console.error({ error });
    // await this.machineService.Update(id, machineData);
  }

  @Selector()
  static issues(state: IssueStateModel) {
    return state.issues;
  }

  @Selector()
  static issueState(state: IssueStateModel) {
    return state;
  }
}
